import { useConstantValueInvariant, useConstantLengthInvariant } from "@contember/react-utils";
import { useCallback } from "react";
import { useAccessorUpdateSubscription } from "./useAccessorUpdateSubscription.js";
import { useDesugaredRelativeSingleEntity } from "./useDesugaredRelativeSingleEntity.js";
import { useOnConnectionUpdate } from "../entityEvents/useOnConnectionUpdate.js";
import { useEntityKey } from "./useEntityKey.js";
import { useGetEntityByKey } from "./useGetEntityByKey.js";
function useEntity(...entity) {
  useConstantValueInvariant(entity.length, "useEntity: cannot alternate between providing and omitting the argument.");
  const entityKey = useEntityKey();
  const getEntityByKey = useGetEntityByKey();
  if (entity.length === 0) {
    const getEntityAccessor = useCallback(() => getEntityByKey(entityKey), [entityKey, getEntityByKey]);
    return useAccessorUpdateSubscription(getEntityAccessor);
  }
  const sugaredRelativeSingleEntity = entity[0];
  const relativeSingleEntity = useDesugaredRelativeSingleEntity(sugaredRelativeSingleEntity);
  const getEntity = useCallback(() => {
    const parent = getEntityByKey(entityKey);
    return parent.getRelativeSingleEntity(relativeSingleEntity);
  }, [entityKey, getEntityByKey, relativeSingleEntity]);
  if (relativeSingleEntity) {
    useConstantLengthInvariant(
      relativeSingleEntity.hasOneRelationPath,
      "Cannot change the length of the hasOneRelation path!"
    );
    const [entity2, forceUpdate] = useAccessorUpdateSubscription(getEntity, true);
    if (relativeSingleEntity.hasOneRelationPath.length) {
      useOnConnectionUpdate(relativeSingleEntity.hasOneRelationPath[0].field, forceUpdate);
    }
    return entity2;
  }
  return void 0;
}
export {
  useEntity
};
//# sourceMappingURL=useEntity.js.map
